import * as types from "../ActionType";

const initState = {
    projectTypes: [],
    loadingProjectTypes: true
}

const ProjectTypeReducer = (state = initState, action) => {
    switch (action.type) {
        case types.ADD_PROJECTTYPE:
            return { ...state, loadingProjectTypes: true }
        case types.GET_PROJECTTYPES:
            return { ...state, projectTypes: action.payload, loadingProjectTypes: false }
        case types.DELETE_PROJECTTYPE:
            return { ...state }
        case types.EDIT_PROJECTTYPE:
            return { ...state, loadingProjectTypes: true }
        default:
            return state;
    }
};

export default ProjectTypeReducer;
